module.exports = __webpack_public_path__ + "img/article_c.37f11808.svg";